module.exports = __webpack_public_path__ + "media/react/marketing/sections/value_props/assets/purple/score_gauge_icon-a8d03a6f1c643baf35ee60af1a8e4bb3.svg";